export enum RouteGuard {
  Admin = 'admin',
  Client = 'client',
  Anonymous = 'anonymous'
}

export enum RouteState {
  NewAd = '/stelle-anlegen',
  EditAd = '/stelle-bearbeiten',
  Login = '/',
  Logout = '/logout',
  Ads = '/stellen-verwalten',
  Faq = '/faq',
  Account = '/account',
  SignUp = '/signup',
  SignUpSuccess = '/signup-success',
  PasswordReset = '/reset-password',
  NewPassword = '/new-password'
}

interface Storyblok {
  before: string
  after?: string
}

export interface RouteConfig {
  name: string
  path: string
  exact?: boolean
  component: any
  guard?: RouteGuard
  storyblok?: Storyblok
}
